import {createActorContext} from '@xstate/react';
import React from 'react';
import {Node, Edge} from 'reactflow';

import {EntityMapEntityNodeOrInaccessibleInfoNode} from 'graphql-client/__generated/graphqlGlobalTypes';
import {LayoutSettings} from 'ui-library/reactflow/layout/calculateDimensionsForLayout';

import {EntityMapMachine} from './EntityMapMachine';

// Create the actor context for the EntityMapMachine
export const EntityMapMachineContext = createActorContext(EntityMapMachine);
export const useEntityMapActorRef = EntityMapMachineContext.useActorRef;
export const useEntityMapSelector = EntityMapMachineContext.useSelector;

// Provider component to wrap the subtree
export const EntityMapMachineProvider = ({
  entityId,
  layoutSettings,
  children,
}: {
  entityId: string;
  layoutSettings: Partial<LayoutSettings<Node<EntityMapEntityNodeOrInaccessibleInfoNode>, Edge>>;
  children: React.ReactNode;
}): JSX.Element => (
  <EntityMapMachineContext.Provider options={{input: {entityId, layoutSettings}}}>
    {children}
  </EntityMapMachineContext.Provider>
);
